module.exports = __webpack_public_path__ + "img/boom.782ca372.png";